import { format, isValid, parseISO } from 'date-fns';

/**
 * Convert ISO date string to format MM/dd/yyyy in local time.
 *
 * @param dateString - ISO date string
 * @param separator - default is '/'
 *
 * @returns formatted date - MM/dd/yyyy, or original string if invalid
 */
export const dateToMDY = (
    dateString: string,
    separator: string = '/'
): string => {
    const parsed = parseISO(dateString);
    if (!isValid(parsed)) {
        return dateString;
    }

    return format(parsed, `MM${separator}dd${separator}yyyy`);
};
